"use client";

import React from "react";
import EditSection, { TextEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function CorporateHeroEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const updateContent = (key: string, value: any) => {
    onContentChange?.({ ...content, [key]: value });
  };

  return (
    <EditSection
      content={content}
      onContentChange={onContentChange || (() => {})}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Hero Content</h4>
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => updateContent("title", v)}
              placeholder="Build Trust. Scale Fast."
            />
            <TextEditor
              label="Subtitle"
              value={content.subtitle}
              onChange={(v) => updateContent("subtitle", v)}
              placeholder="We provide enterprise-grade infrastructure..."
              multiline
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Buttons</h4>
            <TextEditor
              label="Primary CTA Text"
              value={content.primaryCta}
              onChange={(v) => updateContent("primaryCta", v)}
              placeholder="Request Demo"
            />
            <TextEditor
              label="Primary CTA Link"
              value={content.primaryBtnLink}
              onChange={(v) => updateContent("primaryBtnLink", v)}
              placeholder="#demo"
            />
            <TextEditor
              label="Secondary CTA Text"
              value={content.secondaryCta}
              onChange={(v) => updateContent("secondaryCta", v)}
              placeholder="Case Studies"
            />
            <TextEditor
              label="Secondary CTA Link"
              value={content.secondaryBtnLink}
              onChange={(v) => updateContent("secondaryBtnLink", v)}
              placeholder="#studies"
            />
          </div>
        </div>
      }
    />
  );
}
